import { Injectable } from '@angular/core';
import { forkJoin } from 'rxjs';
import { DataContextService } from '../../datacontext.service';
import * as moment from 'moment';
import {  map } from 'rxjs/operators';   
import { Amenity, AttachmentFileExtension, AttachmentFileType, Building, BuildingFeatureFlagsEnum, Configuration, EventType, Item, ItemWithDescription, ItemWithDisplayName, JobTitle, Neighborhood, ServiceOrderType, SpaceFeature, SpaceSetupType, SpaceType, Status, StatusReasons, TaskType, TimeZone, ViewTab, VirtualBookingAdditionalDetail } from '../../../models/masterdata.model';
import { UserSettingsService } from '../../user-settings.service';
import { Facility } from '../../../models/masterdata.model';
import { COUNTRIES } from 'src/app/shared/utils/constants';

@Injectable({
  providedIn: 'root'
})
export class MasterdataService {

  constructor(private dataContextService: DataContextService, private userSettingsService: UserSettingsService) { }
  favoriteViewData: any;

  getMasterData() {
    return forkJoin({
      TimeZones: this.getTimeZones(),
      // VirtualBookingAdditionalDetails: this.getVirtualBookingAdditionalDetails(),
      // VirtualBookingTechnologyAccounts: this.getVirtualBookingTechnologyAccounts(),
      TaskTypes: this.getTaskTypes(),
      ServiceOrderTypes: this.getServiceOrderTypes(),
      // Neighborhoods: this.getNeighborhoods(),
      Series: this.getSeries(),
      TaskStatuses: this.getTaskStatuses(),
      CateringStatuses: this.getCateringStatuses(),
      WaitlistStatuses: this.getWaitlistStatus(),
      BookingStatus: this.getSpaceBookingStatus(),
      ReservationStatus: this.getReservationStatus(),
      // VirtualBookingStatus: this.getVirtualBookingStatus(),
      SpaceTypes: this.getSpaceTypes(),
      SpaceFeatures: this.getSpaceFeatures(),
      EventTypes: this.getEventTypes(),
      SpaceSetupTypes: this.getSpaceSetupTypes(),
      Configurations: this.getConfigurations(),
      MeetingWaitListRequestTypes: this.getMeetingWaitListRequestTypes(),
      MeetingWaitListStatuses: this.getMeetingWaitListStatuses(),
      // AttachmentFileExtensions: this.getAttachmentFileExtensions(),
      // AttachmentFIleTypes: this.getAttachmentFileTypes(),
      StatusReasons: this.getStatusReasons(),
      SpaceSubTypes: this.getSpaceSubTypes(),
      MemberFirmConfigurations: this.getMemberFirmConfiguration(DataContextService.UserData?.memberFirm?.id, this.dataContextService.languageId),
      Amenities: this.getAmenities(),
      JobTitles: this.getJobTitles(),
      MealOptions: this.getMealOptions(),
      Buildings: this.getBuildings()
    })
  }

  getTimeZones(startDate: Date | null = null) {
    let url = '';
    if (startDate) {
      url = `TimeZones?pointOfTime=${encodeURIComponent(moment(startDate).format('YYYY-MM-DDTHH:mm:sszzzz'))}`;
    } else {
      url = `TimeZones`;
    }
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as TimeZone[])
    );
  }

  getVirtualBookingAdditionalDetails() {
    const url = `VirtualBookingAdditionalDetails/ByCategory`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as VirtualBookingAdditionalDetail[])
    );
  }
  mapVirtualOptions(data){
    let virtualOptions = [];
    if(data){
    data.forEach(x => {
      x.virtualBookingAdditionalDetails.forEach(i => {
        virtualOptions.push(i);
      })
    })
    if(virtualOptions){
      return virtualOptions;
    }
   }
  }
  getVirtualBookingTechnologyAccounts() {
    const url = `VirtualBookingTechnologyAccounts`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as Item[])
    );
  }
  getTaskTypes() {
    const url = `Tasks/TaskTypes`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as TaskType[])
    )
  }
  getServiceOrderTypes() {
    const url = `ServiceOrderType`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => {
        const data = res.data as ServiceOrderType[];
        return data.filter(item => item.serviceOrderCategory !== 'EAM'); 
      }),
    )
  }
  getNeighborhoods() {
    const url = `Neighborhoods`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as Neighborhood[])
    );
  }
  getSeries() {
    const url = `Series`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as Item[])
    );
  }
  getCateringStatuses() {
    const url = `MasterData/CateringStatus`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as Status[])
    )
  }
  getTaskStatuses() {
    const url = `MasterData/TaskStatus`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as Status[])
    )
  }
  getWaitlistStatus() {
    const url = `MasterData/WaitlistStatus`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as Status[])
    )
  }
  getSpaceBookingStatus() {
    const url = `MasterData/SpaceBookingStatus`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as Status[])
    )
  }
  getReservationStatus() {
    const url = `MasterData/ReservationStatus`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as Status[])
    )
  }
  getVirtualBookingStatus() {
    const url = `MasterData/VirtualBookingStatus`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as Status[])
    )
  }
  getSpaceTypes() {
    const url = `SpaceTypes`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as SpaceType[] )
    )
  }
  getSpaceFeatures() {
    
    const url = `SpaceFeatures`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => {
        const data = res.data as SpaceFeature[];
        return data.map(item => {
          return {
            ...item,
            iconKey: !item.iconKey ? item.name.split(" ").join("") : item.iconKey
          };
        }).map(item => {
          return {
            ...item,
            iconClass: this.userSettingsService.spaceFeaturesIcon[item.iconKey]
          };
        })
      })
    );
  }
  getEventTypes() {
    const url = `EventTypes/Meeting`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as EventType[])
    );
  }
  getSpaceSetupTypes() {
    const url = `SpaceSetupTypes`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => {
        const data = res.data as SpaceSetupType[];
        return data.sort(a => a.description.toLowerCase() === this.dataContextService.translateText('Translation.Defaultspacesetuptype').toLowerCase() ? -1 : 0).map(item => {
          return {
            ...item,
            iconClass: this.userSettingsService.setupTypeIcon[item.id]
          };
        })
      })
    );
  }
  getConfigurations() {
    const url = `Configuration/Settings`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as Configuration[])
    );
  }
  getMemberFirmConfiguration(memberFirmId: number, languageId: number) {
    const defaultLanguageId = 1 // english only
    const url = `MemberFirm/Settings/${defaultLanguageId}`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as Configuration[])
    );
  }
  getMeetingWaitListRequestTypes() {
    const url = `MasterData/MeetingRequestType`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as ItemWithDisplayName[])
    );
  }
  getMeetingWaitListStatuses() {
    const url = `MasterData/MeetingRequestStatus`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as Status[])
    );
  }
  getAttachmentFileExtensions() {
    const url = `Attachments/FileExtensions`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as AttachmentFileExtension[])
    );
  }
  getAttachmentFileTypes() {
    const url = `Attachments/FileTypes`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as AttachmentFileType[])
    );
  }
  getStatusReasons() {
    const url = `StatusReasons`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as StatusReasons[])
    );
  }
  getSpaceSubTypes() {
    const url = `SpaceSubTypes`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as ItemWithDescription[])
    );
  }
  getAmenities() {
    const url = `Amenities`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as Amenity[])
    );
  }
  getJobTitles() {
    const url = `Users/GetJobTitles`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as JobTitle[])
    );
  }
  getMealOptions() {
    const url = `CateringOrders/MealOptions`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as Item[])
    );
  }
  getBuildings(buildingFeatureFlag = `${BuildingFeatureFlagsEnum[BuildingFeatureFlagsEnum.IncludeFloorInformation]},${BuildingFeatureFlagsEnum[BuildingFeatureFlagsEnum.IncludeFloorAmenities]}`) {
    const url = `Buildings?BuildingFeatureFlags=${buildingFeatureFlag}`;
    return this.dataContextService.getData(url, true, false, true).pipe(
      map(res => res.data as Building[]
          )
    );
  }
  getBuildingById(id: number, features: string | null = null) {
    let url = `Buildings/${id}`;
    if (features)
      url = `${url}/${features}`;
    return this.dataContextService.getData(url).pipe(
      map(res => res.data as Building)
    );
  }
  getFilteredBuildings(): Array<Facility> {
    let preferredCountries = this.getViewTab('countries').map((id) => {
        return COUNTRIES.find((item) => item.id == Number(id)).name;
    });
    return DataContextService.FacilityArray.filter((item) => {
        if (preferredCountries.find((countries) => countries == item.Country))
            return item; 
    });
}
getViewTab(key: any, isTabField?: boolean) {
  let tabFieldValue: any;
  let tabFieldArray = new Array<string>();
  if (this.favoriteViewData) {
    if (!isTabField) {
      tabFieldValue = this.favoriteViewData[key];
    } else {
      let tabData = this.favoriteViewData.viewDetails.find((x) => x.tabFieldId == key);
      if (tabData) { tabFieldValue = tabData.value;}
    }
  }

  if(typeof tabFieldValue == 'string') {
    if(tabFieldValue != null && tabFieldValue !=""){
      tabFieldArray = tabFieldValue.split(',');
    }
  }
  else {
    if ( tabFieldValue) tabFieldArray.push(tabFieldValue);
  }

  return tabFieldArray;
}
getBuildingByName(buildingName: string): Facility {
  return DataContextService.FacilityArray.find((building) => building.OfficeName == buildingName);
}
 
}
